// variables
var page 					= "#page";
var sidebar 				= "#sidebar";
var search_header 			= "#search_input_box";
var productslist_navigation	= "#productslist_navigation";
var spinner 				='<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div><div class="rect6"></div><div class="rect7"></div><div class="rect8"></div><div class="rect9"></div><div class="rect10"></div></div>';
var window_width			= window.innerWidth;

let anchorlinks = document.querySelectorAll('a[href^="#"]')

for (let item of anchorlinks) {
    item.addEventListener('click', (e) => {
        let hashval = item.getAttribute('href')
        let target = document.querySelector(hashval)
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
        history.pushState(null, null, hashval)
        e.preventDefault()
    })
}

//Encoding: UTF-8
$(document).ready(function() {

	// Moodbar
	$(".moodbar-content").slick({
		autoplay: true,
		autoplaySpeed: 10000,
		lazyLoad: 'ondemand',
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		dots:	true,
		arrows:	false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					arrows:	true,
				}
			}
		],
		nextArrow: '<div class="slick-next"><i class="fa fa-angle-right"></i></div>',
		prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left"></i></div>'
	});

	/* init chosen dropdowns */
	init_chosen();

	// slowly scrolling to the top of the page
	$("#goto").on("click", function(e){
		$("html, body").animate({
			scrollTop:$('#header').offset().top
		},"slow");
		e.preventDefault();
	});

	// show button to go while scrolling the page
	$(window).scroll(function(){
		if($(window).scrollTop() > 150){
			//begin to scroll
			$("#goto").css("display","block");
			$("#goto").css("position","fixed");
			$("#goto").css("bottom","5%");
			$("#goto").css("right","5%");
		}
		else{
		//lock it back into place
		$("#goto").css("position","relative");
		$("#goto").css("display","none");
		}
	});

	init_svg_images();
	init_menu_overlay();
	init_menu_header_overlay();
	init_images();
	init_to_top_button();

	$('[data-toggle="popover"]').popover();

	// Collapse: toggle arrows
	$('.collapse')
	.on('show.bs.collapse', function() {
		var $this = $(this);
		if (!$this.hasClass('show')) {
			var $icon = $this.prev().find('.fa');
			$icon.removeClass('fa-angle-down');
			$icon.addClass('fa-angle-up');
		}
	})
	.on('hidden.bs.collapse', function() {
		var $this = $(this);
		if (!$this.hasClass('show')) {
			var $icon = $(this).prev().find('.fa');
			$icon.removeClass('fa-angle-up');
			$icon.addClass('fa-angle-down');
		}
	});
	// Entferne Error Class nach KLICK
	$(".error-line").click(function(){
		$(this).removeClass('error-line');
		$(".cr").removeClass('error-line');
	});
	// Für Target_blank HTML-konform
	$("a[rel=external]").attr("target","_blank");
	$("a[rel=top]").attr("target","_top");
	$("a[rel=self]").attr("target","_self");

	$(".mehrfachlizenzen-button").click(function(){
		$(".mehrfachlizenzen-liste").slideToggle("slow");
		$("#plus").toggleClass("fa-plus fa-minus");
	});

	// Typeahead
	if ( window_width >= 768 ) {
		init_typeahead();
	}

	updatePrices();
});

/**
 * init svg images
 * */
function init_svg_images() {
	// SVGs durch inline SVG-Code ersetzen
	$('img.svg').each(function() {
		var $img 		= $(this);
		var img_id 		= $img.attr('id');
		var img_class 	= $img.attr('class');
		var img_url 	= $img.attr('src');

		jQuery.get(img_url, function(data) {
			// Get the SVG tag, ignore the rest
			var $svg = jQuery(data).find('svg');

			// Add replaced image's ID to the new SVG
			if(typeof img_id !== 'undefined') {
				$svg = $svg.attr('id', img_id);
			}
			// Add replaced image's classes to the new SVG
			if(typeof img_class !== 'undefined') {
				$svg = $svg.attr('class', img_class+' replaced-svg');
			}

			// Remove any invalid XML tags as per http://validator.w3.org
			$svg = $svg.removeAttr('xmlns:a');

			// Replace image with new SVG
			$img.replaceWith($svg);

		}, 'xml');
	});
}

/**
 * bind "chosen" plugin for customizing select boxes
 * */
function init_chosen() {
	$(".chosen-dropdown").chosen({
		width:						'100%'
		,disable_search:			true
		,inherit_select_classes:	true
	});
	$(".chosen-single > div b").html("<i class='fa fa-angle-down fa-lg'></i>");
}

/**
 * functions for navigation
 * */
function init_sidebar(){
	if ($(page).css("position") == "fixed") {
		close_sidebar();
	} else {
		$(page).css("position", "fixed");
		$(page).css("transform", "translate3d(-300px,0,0)");
		$(sidebar).css("transform", "translate3d(0px,0,0)");
		$(sidebar).css("display", "block");
	}
}

function close_sidebar(){
	$(page).css("position", "relative");
	$(page).css("transform", "translate3d(0px,0,0)");
	$(sidebar).css("transform", "translate3d(-300px,0,0)");
	$(sidebar).css("display", "none");
}

function open_submenu(nav_type, content_id) {
	var navigation = "";

	if (nav_type == 'sidebar') {
		navigation = sidebar;
	} else if (nav_type == 'subnavigation') {
		navigation = subnavigation;
	} else if (nav_type == 'productslist_navigation') {
		navigation = productslist_navigation;
	}

	/* open this menu and change arrows*/
	$(navigation + " .angle_down_" + content_id).addClass("hidden");
	$(navigation + " .angle_up_" + content_id).removeClass("hidden");
	$(navigation + " .submenu_" + content_id).slideDown("fast");
}

function close_submenu(nav_type, content_id) {
	var navigation = "";

	var submenu = " .submenu_" + content_id;
	if (nav_type == 'sidebar') {
		navigation = sidebar;
	} else if (nav_type == 'subnavigation') {
		navigation = subnavigation;
	}

	$(navigation + " .angle_up_" + content_id).addClass("hidden");
	$(navigation + " .angle_down_" + content_id).removeClass("hidden");
	$(navigation + submenu).slideUp("fast");
	/* close also submenues */
	$(navigation + submenu + " .submenu").slideUp("fast");
	$(navigation + submenu + " .fa-angle-up").addClass("hidden");
	$(navigation + submenu + " .fa-angle-right").removeClass("hidden");
}

function toggle_search() {
	var search_div = jQuery(search_header);

	if(search_div.is(":visible")){
		search_div.hide();
	} else {
		search_div.show();
	}
}

// lazy-loading
function init_images()
{
	// Lazy loading of images using jquery.unveil
	// Exceptions:
	// - whcaptcha
	// - swiper lazy load
	$(":not(.whcaptcha) img:not(.swiper-lazy)").unveil(20);
}

/**
 * lazy load after every ajax request
 * */
$(document).ajaxComplete(function(event,request, settings ) {
	init_images();
});


/**
 * show main menu overlays on click
 * **/
function init_menu_overlay(){
	var active_id = 0;

	var display_block = "";
	var overlays = ".header-navigation-overlay";
	var id = 0;

	var menu_overlay_mouseover = false;

	$(".header-navigation-menu").on("click", function(e){
		id = $(this).data("overlay");
		e.preventDefault();
		display_block = $("#header_navigation_overlay_" + id).css("display");
		if ( display_block == 'block' || display_block == undefined ) {
			window.location.href = this.href;
			return false;
		}
		$(".menu-to-hover").removeClass("hovered");
		$(overlays).css("display", "none");
		setTimeout(function ()
		{
			$("#header_navigation_overlay_" + id).css("display", "block");
			menu_overlay_mouseover = true;
		}, 10);

	}).on("mouseleave", function(){
		menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!menu_overlay_mouseover) {
				$("#header_navigation_overlay_" + id).css("display", "none");
			}
		}, 400);
	});

	$(overlays).on("mouseover", function(){
		$(this).css("display", "block");
		$("#header_menu_" + id).addClass("hovered");
		menu_overlay_mouseover = true;
	}).on("mouseleave", function(){
		menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!menu_overlay_mouseover) {
				$(overlays).css("display", "none");
				$("#header_menu_" + id).removeClass("hovered");
			}
		}, 400);
	});

	$(".header-navigation-overlay .close").on('click', function(e) {
		close_menu_overlay();
	});
}

function close_menu_overlay() {
	setTimeout(function(){
		$(".closing_menu_wrapper").remove();
	},10)
	$(".closing_menu_wrapper").remove();
	$(".menu-to-hover").removeClass("active-li");
	$(".header-navigation-menu.active").removeClass("active");
	$(".header-navigation-overlay").slideUp(100);
}

function init_menu_header_overlay(){
	var overlays = ".header-subnavigation-overlay";
	var id = 0;

	var menu_overlay_mouseover = false;

	$(".header-subnavigation-menu").on("mouseover", function(){
		if(!($('.check-overlay').css('display')=='none')){
			id = $(this).data("overlay");
			$(".header-subnavigation-menu").removeClass("hovered");
			$(overlays).css("display", "none");
			$("#header_subnavigation_overlay_" + id).css("display", "block");
			menu_overlay_mouseover = true;
		}
	}).on("mouseleave", function(){
		if(!($('.check-overlay').css('display')=='none')){
			menu_overlay_mouseover = false;
			setTimeout(function ()
			{
				if (!menu_overlay_mouseover) {
					$("#header_subnavigation_overlay_" + id).css("display", "none");
				}
			}, 500);
		}
	});

	$(overlays).on("mouseover", function(){
		if(!($('.check-overlay').css('display')=='none')){
			$(this).css("display", "block");
			$("a[data-overlay=" + id + "]").addClass("hovered");
			menu_overlay_mouseover = true;
		}
	}).on("mouseleave", function(){
		if(!($('.check-overlay').css('display')=='none')){
			menu_overlay_mouseover = false;
			setTimeout(function ()
			{
				if (!menu_overlay_mouseover) {
					$(overlays).css("display", "none");
					$("a[data-overlay=" + id + "]").removeClass("hovered");
				}
			}, 500);
		}
	});

}

/* decryptThis E-Mail Adresse entschlüsseln */
function decryptThis(s) {
	var n=0;
	var r="";
	for(var i=0;i<s.length;i++) {
		n=s.charCodeAt(i);
		if (n>=8364) {n = 128;}
		r += String.fromCharCode(n-(2));
	}
	return r;
}

/* decrypt_mail href Attribut entschlüsseln */
function decrypt_mail(element, email, params) {
	if (!params) var params = '';
	element.href = 'mailto:' + decryptThis(email) + params;
}

// Ein Onclick Event von GA triggern
function triggerAnalyticsEvent(name,type,behrsNummer,ga_vier_aktiv) {
	if ( cookiemanager.accepted_statistics ) {
		if ( ga_vier_aktiv == 1 ) {
			gtag('event', type, {
				'event_category': name,
				'event_label'	: behrsNummer
			});
		}
		ga('send','event',name,type,behrsNummer);
	}
}

function init_typeahead(){
	$('#search-input-box input').unbind();

	$('#search-input-box input').each(function(){
		$(this).wh_typeahead({
			ajaxurl			: "/ajax/search"
			,top			: 50
			,right			: -80
			,container		: "#search-input-box"
			,width 			: 740
			,defaultstring	: ''
			,is_academy_page: $('#is_academy_page').val()
		});
	});
}

function init_to_top_button() {
	var a = $("#header").height();
	$(window).bind("scroll", function() {
		if ($(window).scrollTop() > a) {
			$(".totop-button").show();
		} else {
			$(".totop-button").hide();
		}
	});
	// Slowly scrolling to the top of the page
	$(".totop-button").click(function(e){
		$("html, body").animate({
			scrollTop: $("#header").offset().top
		},"slow");
	});
}

function close_banner_button() {
	$.ajax({
		type: 'GET'
		,url: '/ajax/set_banner_session'
		,cache: false
		,success: function(xml,textStatus) {}
		,error: function (XMLHttpRequest, textStatus, errorThrown) {}
	});
	$('#pre-banner').slideUp('slow');
}

/**
 * accept specific cookies in whcookiemanager
 * will reload the page after the cookie has been updated in whCookieManager
 *
 * @consent_type	[string] (marketing|statistics) type of cookies which should be set
 */
function accept_specific_cookies(consent_type) {
	if (typeof cookiemanager !== 'undefined') {
		switch (consent_type) {
			case 'marketing':
			case 'statistics':
				// add eventlistener to verify that the cookie has been updated
				cookiemanager_el = document.getElementById('whCookieManager');
				cookiemanager_el.addEventListener('cookie_changed', (e) => {
					// reload the page
					window.location.reload();
				});
				// update the cookie
				cookiemanager.set_specific_cookie(consent_type);
			break;
		}
	}
}

function toggleShowMore(id = "", showMoreId = "", showLessId = "") {
	var currentActiveProgram = id
	// Do a lookup for select if exists
	if (showMoreId === "show-more-programm") {
		var dropdowns = document.querySelectorAll('[id=seminar-dropdown]');
		if (dropdowns.length > 0) {
			var selectedValue = isParentElementHidden(dropdowns[0]) ? dropdowns[1].value : dropdowns[0].value;
			currentActiveProgram = `program-${selectedValue}`;
		}
	}

	var textRest = document.querySelectorAll(`[id=${currentActiveProgram}]`)
	for (var i = 0; i < textRest.length; i++) {
		textRest[i].hidden = !textRest[i].hidden;
	}

	var showMore = !textRest[0].hidden
	var showLess = textRest[0].hidden

	var showMoreButton = document.querySelectorAll(`[id=${showMoreId}]`)
	var targetShowMoreButton = isParentElementHidden(showMoreButton[0]) ? showMoreButton[1] : showMoreButton[0];
	targetShowMoreButton.hidden = showMore;

	var showLessButton = document.querySelectorAll(`[id=${showLessId}]`)
	var targetShowLessButton = isParentElementHidden(showLessButton[0]) ? showLessButton[1] : showLessButton[0];
	targetShowLessButton.hidden = showLess;
}

function hideAllPrograms(showMoreId = "", showLessId = "") {
	// We need to close/open, hide/show the all elements bcs we have multiple elements with the same id for responsive design
	var textRest = document.querySelectorAll(`[id^="program-"]`)
	for (var i = 0; i < textRest.length; i++) {
		textRest[i].hidden = true;
	}

	var showMoreButton = document.querySelectorAll(`[id=${showMoreId}]`)
	for (var i = 0; i < showMoreButton.length; i++) {
		showMoreButton[i].hidden = false;
	}

	var showLessButton = document.querySelectorAll(`[id=${showLessId}]`)
	for (var i = 0; i < showLessButton.length; i++) {
		showLessButton[i].hidden = true;
	}
}

function toggleSeminarDetails(id = '') {
	var chevronIcon = document.querySelectorAll(`[id=appointmentChevronIcon${id}]`);
	var appointmentDescription = document.querySelectorAll(`[id=appointmentDescription${id}]`);
 	$(".termin-status-header" + id).toggleClass('active');
	for (var i = 0; i < chevronIcon.length; i++) {
		if (chevronIcon[i].classList.contains('fa-angle-double-down')) {
			chevronIcon[i].classList.remove('fa-angle-double-down');
			chevronIcon[i].classList.add('fa-angle-double-up');
			appointmentDescription[i].hidden = false;
		} else {
			chevronIcon[i].classList.remove('fa-angle-double-up');
			chevronIcon[i].classList.add('fa-angle-double-down');
			appointmentDescription[i].hidden = true;
		}
	}
}

function changeProgram () {
	var dropdowns = document.querySelectorAll('[id=seminar-dropdown]');
	var selectedValue = isParentElementHidden(dropdowns[0]) ? dropdowns[1].value : dropdowns[0].value;

	// Update program
	var programDivs = document.querySelectorAll('[id^="program-"]');
    var container = document.querySelectorAll("#container-program");
	if (container) {
		container.forEach(function(container) {
			container.classList.remove("expanded");
		});
	}
	programDivs.forEach(div => {
        if (div.id === `program-${selectedValue}`) {
            div.style.display = 'block'; // Show the selected program
        } else {
            div.style.display = 'none'; // Hide other programs
        }
    });

	// Update program container height
	toggleSpanVisibility();

	// Update prices in info box
	updatePrices();
}

function updatePrices() {
	var dropdowns = document.querySelectorAll('[id=seminar-dropdown]');
	if (dropdowns.length > 0) {
		var selectedValue = isParentElementHidden(dropdowns[0]) ? dropdowns[1].value : dropdowns[0].value;
		var priceSpans = document.querySelectorAll('[id^="price-"]');
		var vatSpans = document.querySelectorAll('[id^="vat-"]');
		var daysSpans = document.querySelectorAll('[id^="days-"]');
		var subscribeButtons = document.querySelectorAll('[id^="button-subscribe-"]');

		priceSpans.forEach(span => {
			span.style.display = span.id === `price-${selectedValue}` ? 'block' : 'none';
		});
		vatSpans.forEach(span => {
			span.style.display = span.id === `vat-${selectedValue}` ? 'block' : 'none';
		});
		daysSpans.forEach(span => {
			span.style.display = span.id === `days-${selectedValue}` ? 'block' : 'none';
		});
		subscribeButtons.forEach(span => {
			span.style.display = span.id === `button-subscribe-${selectedValue}` ? 'block' : 'none';
		});
	}
}

function isParentElementHidden(element) {
	if (!element) {
		return true;
	}

	var firstParent = element.closest('.d-lg-none');

	// Ensure the parent exists before calling getComputedStyle on it
	if (firstParent) {
		var isLgInlineActive = window.getComputedStyle(firstParent).display;

		// Check if the display is set to 'none', meaning it's hidden
		return isLgInlineActive === 'none';
	}
	return false;
}

function scrollToElementTermine()	{
	var elements = document.querySelectorAll('[id^="termine"]');
	if (elements.length > 0) {
		var parentElement = isParentElementHidden(elements[0]) ? elements[1] : elements[0];
		parentElement.scrollIntoView({behavior: "smooth"});
	}
}

function toggleSpanVisibility() {
    var container = document.querySelectorAll("#container-program");
    var showMoreSpan = document.querySelectorAll("#show-more-programm"); 
    var showLessSpan = document.querySelectorAll("#show-less-programm"); 
    var programFade = document.querySelectorAll(".program-fade"); 
    if (container && showMoreSpan) {
		var threshold = window.innerWidth < 767 ? 355 : 750;
		var isContainerWithinLimit = (container[0].offsetHeight !== 0 && container[0].offsetHeight < threshold) || (container[1].offsetHeight !== 0 && container[1].offsetHeight< threshold)
        showMoreSpan.forEach(function(button) {
			if ((container[0].offsetHeight !== 0 && container[0].offsetHeight < threshold) || (container[1].offsetHeight !== 0 && container[1].offsetHeight< threshold)) {
				button.classList.add("hidden");
			} else {
				button.classList.remove("hidden");
				button.classList.add("visible");
			}
		});
        showLessSpan.forEach(function(button) {
			if (isContainerWithinLimit) {
				button.classList.add("hidden");
			} else if (isContainerWithinLimit && showMoreSpan[1].classList.contains("hidden")) {
				button.classList.remove("hidden");
				button.classList.add("visible");
			}
		});
        programFade.forEach(function(button) {
			if (isContainerWithinLimit) {
				button.classList.add("hidden");
			} else {
				button.classList.remove("hidden");
				button.classList.add("visible");
			}
		});
    }
}

document.addEventListener("DOMContentLoaded", function () {
	toggleSpanVisibility();
});

function expandProgram(id) {
    let containers = document.querySelectorAll("#container-program");
    let fadeEffects = document.querySelectorAll(".program-fade");
    let showMoreButtons = document.querySelectorAll("#show-more-programm");
    let showLessProgram = document.querySelectorAll("#show-less-programm");

    containers.forEach(function(container) {
        container.classList.add("expanded");
    });

    fadeEffects.forEach(function(fadeEffect) {
        fadeEffect.classList.add("hidden");
    });

    showMoreButtons.forEach(function(button) {
        button.classList.add("hidden");
    });

	showLessProgram.forEach(function(button) {
		button.classList.remove("hidden");
		button.classList.add("visible");
	});
}

function collapseProgram() {
	let containers = document.querySelectorAll("#container-program");
	let fadeEffects = document.querySelectorAll(".program-fade");
	let showMoreButtons = document.querySelectorAll("#show-more-programm");
	let showLessProgram = document.querySelectorAll("#show-less-programm");

	containers.forEach(function(container) {
		container.classList.remove("expanded");
	});

	fadeEffects.forEach(function(fadeEffect) {
		fadeEffect.classList.remove("hidden");
	});

	showMoreButtons.forEach(function(button) {
		button.classList.remove("hidden");
	});

	showLessProgram.forEach(function(button) {
		button.classList.add("hidden");
		button.classList.remove("visible");
	});

	// Scroll to the top of the Program section
	var elements = document.querySelectorAll('[id^="main-content"]');
	elements.forEach(function(element) {
		element.scrollIntoView({behavior: "smooth"});
	});
}
